import { RepositoryFactory } from '@/api/RepositoryFactory'

export const GET_PAYMENTS = 'GET_PAYMENTS'
export const GET_PAYMENTS_BY_ID = 'GET_PAYMENTS_BY_ID'
export const SEND_PAYMENT = 'SEND_PAYMENT'
export const DELETE_PAYMENT = 'DELETE_PAYMENT'
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT'

const SET_LOADING = 'SET_LOADING'
const SET_PAYING_LOADER = 'SET_PAYING_LOADER'
const paymentsApi = RepositoryFactory.get('payments')

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    payingLoader: false,
  },
  getters: {
    getPayments: state => state.list,
    getLoading: state => state.loading,
    getLoader: state => state.payingLoader,
  },
  mutations: {
    [GET_PAYMENTS](state, payload = []) {
      state.list = payload
    },
    [SEND_PAYMENT](state, payload) {
      state.list.unshift(payload)
    },
    [DELETE_PAYMENT](state, payload) {
      state.list = state.list.filter(c => c.id !== payload)
    },
    [UPDATE_PAYMENT]() {
      // TODO
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
    [SET_PAYING_LOADER]: (state, flag) => {
      state.payingLoader = Boolean(flag)
    },
  },
  actions: {
    async [GET_PAYMENTS]({ commit }) {
      commit(SET_LOADING, true)
      try {
        const resp = await paymentsApi.listAll()

        commit(GET_PAYMENTS, resp.data)
      } catch (error) {
        console.log(`payment error: `, error)
      } finally {
        commit(SET_LOADING)
      }
    },
    async [GET_PAYMENTS_BY_ID]({ commit }, id) {
      commit(SET_LOADING, true)
      try {
        const resp = await paymentsApi.listById(id)

        commit(GET_PAYMENTS, resp.data)
      } catch (error) {
        console.log(`payment error: `, error)
      } finally {
        commit(SET_LOADING)
      }
    },
    async [SEND_PAYMENT]({ commit }, data) {
      commit(SET_PAYING_LOADER, true)
      try {
        const resp = await paymentsApi.create(data)

        commit(SEND_PAYMENT, resp.data)
      } catch (error) {
        console.log(`payment error: `, error)
      } finally {
        commit(SET_PAYING_LOADER)
      }
    },
    async [UPDATE_PAYMENT]({ commit }, payload) {
      await paymentsApi
        .update(payload.id, { payment_number: payload.payment_number })
        .then(() => commit(UPDATE_PAYMENT))
    },
    async [DELETE_PAYMENT]({ commit }, data) {
      await paymentsApi.delete(data).then(() => commit(DELETE_PAYMENT, data))
    },
  },
}
